import Logger from 'Common/logs/Logger';
import BrowserTransport from 'Browser/logs/BrowserTransport';
import BrowserFormat from 'Browser/logs/BrowserFormat';
import { createViteBrowserRouter, createBrowserRouter } from 'Shared/Root';
import { hydrate, render } from 'solid-js/web';
import { Environment } from 'Common/Environment';
import { SiteBasics } from 'Common/SiteBasics';
import { User } from 'Browser/User';
import { createTRPCClient, httpBatchLink, httpLink } from '@trpc/client';
import type { AppRouter } from 'Server/rpc/router';
import { parse, stringify } from 'devalue';


export class Browser
{
	constructor(
		private build:Environment,
		private site:SiteBasics,
		private user:User
	)
	{}

	async run()
	{
//XXX perhaps raise the level for production   
		window.log = new Logger(undefined);
		log.add(new BrowserTransport(),new BrowserFormat(),'debug');

		const server = initTrpcClient();

		const basicData = {
			build: this.build,
			site: this.site,
			user: this.user,
			server: server
		};

		handleRejectedPromises(server);

		try {

			if (window.useVite) 
				render(createViteBrowserRouter(basicData), document.getElementById('root') as HTMLElement);
			else
				hydrate(createBrowserRouter(basicData), document);
		}
		catch (err) {
			/* These are "top level" errors that indicate the router has crashed or failed to start. Hopefully rare. */
			log.error(err);
			server.logBrowserError.mutate({type:'top level',location:location.href,message:err.message,stack:err.stack});
			alert(`An error occurred: ${err.message}. Perhaps try refreshing the browser page.`);
		}
	}
}

function handleRejectedPromises(server)
{
	let inError = false;

	window.onunhandledrejection = async (err) => {
		//XXX this is needed in Chrome for some reason
		log.error(err.reason.message);

		if (!inError) {
			inError = true;
			await server.logBrowserError.mutate({type:'unhandledRejection',location:location.href,message:err.reason.message,stack:err.reason.stack});
			inError = false;				
			alert(`An error occurred: ${err.reason.message}. Perhaps try refreshing the browser page.`);
		}
	};
}

export function initTrpcClient()
{
	const transformer = {
		deserialize: (object: any) => {
			return parse(object, {
//TODO in time create an Id class instead of using a string
				ObjectId: value => value
			})
		},

		serialize: (object: any) => {
			return stringify(object);
		}
	};

	return createTRPCClient<AppRouter>({
		links: [
//			httpLink({url: '/_rpc',transformer }),    //XXX this is giving errors for some reason... probably thes transformer

			/*
				WARNING: 
				Turning off batching doesn't really guarantee that operations will occur in the correct order on the server 
				as requests can still come in separately and overlap in the server - its just less likely to occur.
				Arguably its better to enable batching because we're more likely to detect problems.

				NOTE: can turn off batching in createRouter.ts (server-side) using the 'allowBatching' option.
				      Presumably 'maxItems' here would do the same thing.
					  httpLink() could be used instead but is throwing errors for some reason.
			*/			
			httpBatchLink({
				url: '/_rpc',
//				maxItems: 1,
				transformer,
			}),
		],
	});
}

